$(function () {
    var body = $('body');
    var main = $('main');
    var nav = $('.nav');
    var burger = $('.burger');
    var nav_trigger = $('.nav').find('ul li');
    var meganav_trigger = $('.megamenu').find('.megamenu-nav');
    var megamenu_window = $('.megamenu');
    var megamenu_active = nav_trigger.children('.megamenu.__active');
    var nav_align = 'right';
    var break_point = 992;
    var browser_width = window.innerWidth;
    var nav_width = 300;
    var nav_window = $('<div class="navwindow"></div>');
    body.append(nav_window);
    var nav_wrap = $('.navwrap');

    nav_window.click(function (event) {
        nav_reset();
    });

    //burger click
    burger.click(function (event) {
        event.preventDefault();
        $(this).toggleClass('__active');
        if (body.hasClass('__mobile')) {
            nav_reset();
        } else {
            nav_launch();
        }
    });

    /*nav reset*/
    var nav_reset = function nav_reset() {
        burger.removeClass('__active');
        nav_window.hide();
        body.removeClass('__mobile');
        nav_wrap.removeClass('__active');
        nav_wrap.find('ul').removeClass('__active');
        megamenu_window.removeClass('__active');
    };

    /*nav launch*/
    var nav_launch = function nav_launch() {
        nav_window.show();
        body.addClass('__mobile');
        nav_wrap.addClass('__active');
    };



    var nav_ul = $('.nav ul li > ul');
    var nav_ul_child = $('.nav ul.childMenu');
    var nav_ul_grandchild = $('.nav ul li > ul.grandchildMenu');
    var nav_megamenu = $('.nav ul li > .megamenu');
    var sub_title = $('<li><h3 class="mobile-menu-title __title-uppercase __sub"></h3></li>');
    var back_button = $('<li class="backto"><a href="#">Back</a></li>');
    var back_button_parent = $('<li class="backtoparent"><a href="#">Back</a></li>');
    var back_button_mega = $('<li class="backtomega"><a href="#">Back</a></li>');
    
    function initMenu() {
        var browser_width = window.innerWidth;

         // nav dropdown on focus/keyboard navigation
        if (browser_width >= break_point) {
            $('.menu-item').focusin(function () {
                $(this).addClass('__active');
                $(this).children('button').attr('aria-expanded', true);
            });
            $('menu-item-has-megamenu').focusin(function () {
                $(this).addClass('__active');
                $(this).children('button').attr('aria-expanded', true);
                $(this).children('.megamenu').addClass('__active');
                main.addClass('__bg-blur');
            });
            $('.menu-item').focusout(function () {
                $(this).removeClass('__active');
                $(this).children('button').attr('aria-expanded', false);
                $(this).children('.megamenu').removeClass('__active');
                main.removeClass('__bg-blur');
            });
            $('.menu-item').mouseover(function () {
                $(this).children('button').attr('aria-expanded', true);
            });
            $('.menu-item-has-megamenu').mouseover(function () {
                $(this).children('button').attr('aria-expanded', true);
                $(this).children('.megamenu').addClass('__active');
                main.addClass('__bg-blur');
            });
            $('.menu-item').mouseout(function () {
                $(this).children('button').attr('aria-expanded', false);
                $(this).children('.megamenu').removeClass('__active');
                main.removeClass('__bg-blur');
            });
            $('.menu-item-has-megamenu').click(function () {
                $(this).children('.megamenu').toggleClass('__active');
                main.toggleClass('__bg-blur');
            });
        }

        if (browser_width < break_point) {
            nav_trigger.click(function (event) {
                event.stopPropagation();
                if ($(this).children('ul').length > 0) {
                    event.preventDefault();
                    $(this)
                        .parents('ul')
                        .removeClass('__active');
                    $(this)
                        .children('ul')
                        .addClass('__active');
                }
                if ($(this).children('.megamenu').length > 0) {
                    $(this)
                        .parents('ul')
                        .toggleClass('__active');
                    $(this)
                        .children('.megamenu')
                        .toggleClass('__active');
                }
                if ($(this).children('.megamenu.__active')) {
                    nav_wrap.addClass('__active');
                    $('.mobile-menu-title.__main').hide();
                }
                else {
                    nav_wrap.removeClass('__active');
                    $('.mobile-menu-title.__main').show();
                }
            });
        }

        if (browser_width < break_point) {
            meganav_trigger.click(function (event) {
                event.stopPropagation();
                if ($(this).children('ul').length > 0) {
                    $(this)
                        .parents('.megamenu')
                        .toggleClass('__active');
                    $(this)
                        .children('ul')
                        .toggleClass('__active');
                }
            });
        }

        if (browser_width < break_point) {
            if (nav_ul.has(sub_title).length == 0) {
                nav_ul.prepend(sub_title);
            }
            if (nav_ul_child.has(back_button).length == 0) {
                nav_ul_child.prepend(back_button);
            }
            if (nav_ul_grandchild.has(back_button_parent).length == 0) {
                nav_ul_grandchild.prepend(back_button_parent);
            }
            if (nav_megamenu.has(sub_title).length == 0) {
                nav_megamenu.prepend(sub_title);
            }
            if (nav_megamenu.has(back_button_mega).length == 0) {
                nav_megamenu.prepend(back_button_mega);
            }

            var megamenu_submenu = $('.megamenu-nav > button');
            megamenu_submenu.click(function (event) {
                event.preventDefault();
                event.stopPropagation();
                $(this)
                    .slideDown();
                $(this)
                    .siblings('ul')
                    .toggleClass('__active');
                $(this)
                    .toggleClass('__active');
            })

            var back_menu = $('.backto');
            back_menu.click(function (event) {
                event.preventDefault();
                event.stopPropagation();
                $(this)
                    .parent('ul')
                    .removeClass('__active');
                $(this)
                    .parents('li')
                    .parent('ul')
                    .addClass('__active');
                $('.mobile-menu-title.__main').show();
            });

            var back_menu_parent = $('.backtoparent');
            back_menu_parent.click(function (event) {
                event.preventDefault();
                event.stopPropagation();
                $(this)
                    .parent('ul')
                    .removeClass('__active');
                $(this)
                    .parents('li')
                    .parent('ul')
                    .addClass('__active');
            });

            var back_menu_mega = $('.backtomega');
            back_menu_mega.click(function (event) {
                event.preventDefault();
                event.stopPropagation();
                $(this)
                    .parent('.megamenu')
                    .removeClass('__active');
                $(this)
                    .parents('li')
                    .parent('ul')
                    .addClass('__active');
                $('.navwrap')
                    .addClass('__active');
                $('.mobile-menu-title.__main').show();
            });

        } else {
            if (nav_ul.has(back_button).length) {
                $('.backto').remove();
            }
            nav_reset();
        }

        // Touch device check
        const isTouchDevice = () => {
            return window.matchMedia("(pointer: coarse)").matches
        }
        // If desktop and touch device, disable link click and add extra view link
        if (browser_width > break_point && isTouchDevice()) {
            nav_trigger.click(function (event) {
                event.stopPropagation();
                if ($(this).children('ul').length > 0) {
                    event.preventDefault();
                }
            });
            nav_ul.prepend(sub_title);
        }

        var view_all = $('.viewall');
        view_all.each(function () {
            var parent_url = $(this)
                .closest('ul')
                .siblings()
                .attr('href');
            var parent_title = $(this)
                .closest('ul')
                .siblings()
                .html();
            $(this)
                .find('a')
                .attr('href', parent_url);
            $(this)
                .find('a')
                .html('View ' + parent_title);
        });

        view_all.click(function (event) {
            event.stopPropagation();
        });
    }
    
    initMenu();

    $(window).on('resize', function(){
        initMenu();
    });

});